var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "../../node_modules/tsup/assets/esm_shims.js"() {
  }
});

// ../../node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "../../node_modules/dayjs/dayjs.min.js"(exports, module) {
    init_esm_shims();
    !function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    }(exports, function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
        var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
        return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
      } }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, v = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date())
          return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return void 0 === t2;
      } }, g = "en", D = {};
      D[g] = M;
      var p = "$isDayjsObject", S = function(t2) {
        return t2 instanceof _ || !(!t2 || !t2[p]);
      }, w = function t2(e2, n2, r2) {
        var i2;
        if (!e2)
          return g;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1)
            return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (g = i2), i2 || !r2 && g;
      }, O = function(t2, e2) {
        if (S(t2))
          return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, b = v;
      b.l = w, b.i = S, b.w = function(t2, e2) {
        return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = function() {
        function M2(t2) {
          this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2)
              return new Date(NaN);
            if (b.u(e2))
              return new Date();
            if (e2 instanceof Date)
              return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match($);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          }(t2), this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return b;
        }, m2.isValid = function() {
          return !(this.$d.toString() === l);
        }, m2.isSame = function(t2, e2) {
          var n2 = O(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return O(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < O(t2);
        }, m2.$g = function(t2, e2, n2) {
          return b.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
            var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, $2 = function(t3, e3) {
            return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
          switch (f2) {
            case h:
              return r2 ? l2(1, 0) : l2(31, 11);
            case c:
              return r2 ? l2(1, M3) : l2(0, M3 + 1);
            case o:
              var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
              return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return $2(v2 + "Hours", 0);
            case u:
              return $2(v2 + "Minutes", 1);
            case s:
              return $2(v2 + "Seconds", 2);
            case i:
              return $2(v2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === c || o2 === h) {
            var y2 = this.clone().set(d, 1);
            y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else
            l2 && this.$d[l2]($2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[b.p(t2)]();
        }, m2.add = function(r2, f2) {
          var d2, l2 = this;
          r2 = Number(r2);
          var $2 = b.p(f2), y2 = function(t2) {
            var e2 = O(l2);
            return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
          };
          if ($2 === c)
            return this.set(c, this.$M + r2);
          if ($2 === h)
            return this.set(h, this.$y + r2);
          if ($2 === a)
            return y2(1);
          if ($2 === o)
            return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return b.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid())
            return n2.invalidDate || l;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, d2 = function(t3) {
            return b.s(s2 % 12 || 12, t3, "0");
          }, $2 = f2 || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          };
          return r2.replace(y, function(t3, r3) {
            return r3 || function(t4) {
              switch (t4) {
                case "YY":
                  return String(e2.$y).slice(-2);
                case "YYYY":
                  return b.s(e2.$y, 4, "0");
                case "M":
                  return a2 + 1;
                case "MM":
                  return b.s(a2 + 1, 2, "0");
                case "MMM":
                  return h2(n2.monthsShort, a2, c2, 3);
                case "MMMM":
                  return h2(c2, a2);
                case "D":
                  return e2.$D;
                case "DD":
                  return b.s(e2.$D, 2, "0");
                case "d":
                  return String(e2.$W);
                case "dd":
                  return h2(n2.weekdaysMin, e2.$W, o2, 2);
                case "ddd":
                  return h2(n2.weekdaysShort, e2.$W, o2, 3);
                case "dddd":
                  return o2[e2.$W];
                case "H":
                  return String(s2);
                case "HH":
                  return b.s(s2, 2, "0");
                case "h":
                  return d2(1);
                case "hh":
                  return d2(2);
                case "a":
                  return $2(s2, u2, true);
                case "A":
                  return $2(s2, u2, false);
                case "m":
                  return String(u2);
                case "mm":
                  return b.s(u2, 2, "0");
                case "s":
                  return String(e2.$s);
                case "ss":
                  return b.s(e2.$s, 2, "0");
                case "SSS":
                  return b.s(e2.$ms, 3, "0");
                case "Z":
                  return i2;
              }
              return null;
            }(t3) || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, l2) {
          var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
            return b.m(y2, m3);
          };
          switch (M3) {
            case h:
              $2 = D2() / 12;
              break;
            case c:
              $2 = D2();
              break;
            case f:
              $2 = D2() / 3;
              break;
            case o:
              $2 = (g2 - v2) / 6048e5;
              break;
            case a:
              $2 = (g2 - v2) / 864e5;
              break;
            case u:
              $2 = g2 / n;
              break;
            case s:
              $2 = g2 / e;
              break;
            case i:
              $2 = g2 / t;
              break;
            default:
              $2 = g2;
          }
          return l2 ? $2 : b.a($2);
        }, m2.daysInMonth = function() {
          return this.endOf(c).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2)
            return this.$L;
          var n2 = this.clone(), r2 = w(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return b.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), k = _.prototype;
      return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function(t2) {
        k[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      }), O.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, O), t2.$i = true), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
        return O(1e3 * t2);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    });
  }
});

// src/index.tsx
init_esm_shims();
import "@d5/i18n";

// src/Layout/index.tsx
init_esm_shims();

// src/Layout/Layout.tsx
init_esm_shims();
import {
  theme
} from "@bigcommerce/big-design-theme";
import {
  ThemeProvider
} from "styled-components";

// src/Layout/LayoutFrame.tsx
init_esm_shims();
import { useState as useState2 } from "react";
import { useTranslation } from "react-i18next";

// src/Layout/Copyright.tsx
init_esm_shims();

// src/Layout/styled.tsx
init_esm_shims();
import styled from "styled-components";
var StyledSidebar = styled("aside")(({
  theme: theme2,
  asideWidth
}) => ({
  backgroundColor: theme2.colors.secondary70,
  color: theme2.colors.white,
  width: asideWidth,
  height: "100vh",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: theme2.zIndex.fixed,
  display: "flex",
  flexDirection: "column"
}));
var StyledSideNav = styled("nav")({
  flex: 1,
  overflowX: "hidden"
});
var StyledHeader = styled("header")(({
  theme: theme2,
  asideWidth
}) => ({
  backgroundColor: theme2.colors.white,
  boxShadow: `${theme2.helpers.createRGBA("#000", 0.05)} 0px 2px 2px, ${theme2.helpers.createRGBA("#000", 0.05)} 0px 2px 4px`,
  height: 64,
  position: "fixed",
  left: asideWidth,
  top: 0,
  right: 0,
  zIndex: theme2.zIndex.fixed,
  display: "flex",
  padding: `0 ${theme2.spacing.xLarge}`,
  justifyContent: "space-between",
  alignItems: "center",
  boxSizing: "border-box"
}));
var StyledRight = styled("div")(({
  asideWidth,
  theme: theme2
}) => ({
  paddingLeft: asideWidth,
  paddingTop: 64,
  display: "flex",
  flexDirection: "column",
  minHeight: "calc(100vh - 64px)",
  color: theme2.colors.secondary60
}));
var StyledContent = styled("section")(({
  theme: theme2
}) => ({
  padding: theme2.spacing.xLarge,
  flex: 1
}));
var StyledCopyright = styled("footer")(({
  theme: theme2
}) => ({
  padding: theme2.spacing.medium,
  color: theme2.colors.secondary60,
  display: "flex",
  justifyContent: "center",
  alignSelf: "center"
}));
var StyledLogoMin = styled("img")({
  padding: 16,
  boxSizing: "border-box",
  width: "100%"
});
var StyleLogoWrapper = styled("div")(({ isRow }) => ({
  padding: 16,
  boxSizing: "border-box",
  width: "100%",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  flexDirection: isRow ? "row" : "column"
}));
var StyledBox = styled("div")(({
  theme: theme2,
  isShadowed = true,
  margin,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight
}) => ({
  backgroundColor: theme2.colors.white,
  padding: theme2.spacing.xLarge,
  margin: margin || 0,
  marginTop: marginTop || 0,
  marginBottom: marginBottom || 0,
  marginLeft: marginLeft || 0,
  marginRight: marginRight || 0,
  boxShadow: isShadowed ? "rgb(49 52 64 / 20%) 0px 1px 6px" : "none"
}));
var StyledLayoutNoFrame = styled("div")(({
  theme: theme2,
  bgImg
}) => ({
  backgroundImage: `linear-gradient(${theme2.colors.white}, ${theme2.colors.white}), url(${bgImg})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "0, cover",
  backgroundPosition: "0 0, center center",
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  [theme2.breakpoints.tablet]: {
    backgroundSize: "65% 100vh, contain",
    backgroundPosition: "right center, left center",
    paddingLeft: !bgImg ? "0" : "35%"
  }
}));
var StyledLayoutNoFrameCopyright = styled("div")(({
  theme: theme2
}) => ({
  position: "absolute",
  bottom: 0,
  padding: theme2.spacing.medium,
  color: theme2.colors.white,
  display: "flex",
  justifyContent: "center",
  alignSelf: "center",
  [theme2.breakpoints.tablet]: {
    color: theme2.colors.secondary60
  }
}));

// src/Layout/Copyright.tsx
import { jsx } from "react/jsx-runtime";
var Copyright = ({
  copyright
}) => /* @__PURE__ */ jsx(StyledCopyright, {
  children: copyright
});

// src/Layout/Header.tsx
init_esm_shims();
import {
  Button
} from "@bigcommerce/big-design";
import {
  MenuIcon
} from "@bigcommerce/big-design-icons";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var Header = ({
  headerExtra,
  asideWidth,
  onToggleMiniNav,
  renderToggleIcon,
  isMiniNav = false
}) => /* @__PURE__ */ jsxs(StyledHeader, {
  asideWidth,
  children: [
    /* @__PURE__ */ jsx2(Button, {
      iconOnly: renderToggleIcon ? renderToggleIcon(isMiniNav) : /* @__PURE__ */ jsx2(MenuIcon, {
        title: "Toggle Sidebar"
      }),
      variant: "subtle",
      onClick: onToggleMiniNav
    }),
    /* @__PURE__ */ jsx2("div", {
      children: headerExtra
    })
  ]
});

// src/Menu/index.tsx
init_esm_shims();
import {
  useState
} from "react";

// src/Menu/styled.tsx
init_esm_shims();
import styled2 from "styled-components";
var StyledMenu = styled2("ul")(({
  theme: theme2,
  backgroundColor
}) => ({
  backgroundColor: backgroundColor != null ? backgroundColor : theme2.colors.secondary70,
  margin: 0,
  padding: 0
}));
var StyledMenuItem = styled2("li")(({
  theme: theme2,
  isMiniNav = false,
  backgroundColor,
  activedBackgroundColor,
  color,
  activedColor,
  isActive = false,
  isSubMenu = false
}) => {
  const bgColor = backgroundColor != null ? backgroundColor : theme2.colors.secondary70;
  const textColor = color != null ? color : theme2.colors.secondary40;
  const activedBgColor = activedBackgroundColor != null ? activedBackgroundColor : theme2.colors.secondary60;
  const activedTextColor = activedColor != null ? activedColor : theme2.colors.white;
  return {
    boxSizing: "border-box",
    backgroundColor: isActive ? activedBgColor : bgColor,
    color: isActive ? activedTextColor : textColor,
    padding: `${isMiniNav ? 0 : theme2.spacing.medium} ${isMiniNav ? 0 : theme2.spacing[isSubMenu ? "xxxLarge" : "medium"]}`,
    cursor: "pointer",
    display: "flex",
    width: isMiniNav ? 64 : "100%",
    height: isMiniNav ? 64 : "100%",
    justifyContent: isMiniNav ? "center" : "flex-start",
    alignItems: "center",
    ":hover": {
      backgroundColor: isActive ? activedBgColor : "#000",
      color: theme2.colors.secondary20
    },
    ".icon": {
      marginRight: isMiniNav ? 0 : theme2.spacing.medium
    }
  };
});

// src/Menu/index.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var Menu = ({
  items,
  isMiniNav,
  selectedKeys = []
}) => {
  const [openKeys, setOpenKeys] = useState([]);
  const handleSubMenuTitleClick = (key) => () => {
    if (openKeys.includes(key)) {
      setOpenKeys(openKeys.filter((openKey) => key !== openKey));
    } else {
      setOpenKeys([...openKeys, key]);
    }
  };
  if (!items)
    return null;
  return /* @__PURE__ */ jsx3(StyledMenu, {
    isMiniNav,
    children: items.length > 0 && items.map((item) => {
      if (item.subMenu && item.subMenu.length > 0) {
        return /* @__PURE__ */ jsxs2("li", {
          children: [
            /* @__PURE__ */ jsxs2(StyledMenuItem, {
              as: "span",
              isActive: selectedKeys.includes(item.key),
              isMiniNav,
              onClick: handleSubMenuTitleClick(item.key),
              children: [
                /* @__PURE__ */ jsx3("span", {
                  className: "icon",
                  children: item.icon
                }),
                /* @__PURE__ */ jsx3("span", {
                  children: !isMiniNav && item.text
                })
              ]
            }),
            openKeys.includes(item.key) && item.subMenu.length > 0 && /* @__PURE__ */ jsx3(StyledMenu, {
              children: item.subMenu.map((subMenuItem) => /* @__PURE__ */ jsxs2(StyledMenuItem, {
                isSubMenu: true,
                isActive: selectedKeys.includes(subMenuItem.key),
                isMiniNav,
                onClick: subMenuItem == null ? void 0 : subMenuItem.onClick,
                children: [
                  /* @__PURE__ */ jsx3("span", {
                    className: "icon",
                    children: subMenuItem.icon
                  }),
                  /* @__PURE__ */ jsx3("span", {
                    children: !isMiniNav && subMenuItem.text
                  })
                ]
              }, subMenuItem.key))
            })
          ]
        }, item.key);
      }
      return /* @__PURE__ */ jsxs2(StyledMenuItem, {
        isActive: selectedKeys.includes(item.key),
        isMiniNav,
        subMenu: item.subMenu,
        onClick: item == null ? void 0 : item.onClick,
        children: [
          /* @__PURE__ */ jsx3("span", {
            className: "icon",
            children: item.icon
          }),
          /* @__PURE__ */ jsx3("span", {
            children: !isMiniNav && item.text
          })
        ]
      }, item.key);
    })
  });
};

// src/Layout/LayoutFrame.tsx
import { Fragment, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var LayoutFrame = ({
  children,
  headerExtra,
  copyright,
  logoSrc,
  brandTitle,
  asideExpandedWidth = 240,
  asideCollapsedWidth = 64,
  menu,
  renderMenu,
  renderToggleIcon,
  sidebarFooter,
  userLogoUrl,
  userLogoTitle
}) => {
  const [isMiniNav, toggleMiniNav] = useState2(false);
  const { t } = useTranslation();
  const onToggleMiniNav = () => toggleMiniNav(!isMiniNav);
  const asideWidth = isMiniNav ? asideCollapsedWidth : asideExpandedWidth;
  const renderLogo = () => {
    if (userLogoUrl || userLogoTitle) {
      return /* @__PURE__ */ jsxs3(StyleLogoWrapper, {
        isRow: false,
        children: [
          /* @__PURE__ */ jsx4("div", {
            style: {
              width: "100%"
            },
            children: userLogoUrl && /* @__PURE__ */ jsx4("img", {
              style: {
                width: "100%",
                objectFit: "contain"
              },
              src: userLogoUrl,
              alt: userLogoTitle
            })
          }),
          userLogoTitle && /* @__PURE__ */ jsx4("div", {
            style: {
              textAlign: "center",
              wordBreak: "break-word",
              wordWrap: "break-word",
              width: "100%"
            },
            children: userLogoTitle
          })
        ]
      });
    }
    return /* @__PURE__ */ jsxs3(StyleLogoWrapper, {
      isRow: true,
      children: [
        /* @__PURE__ */ jsx4("img", {
          style: {
            width: 32,
            height: 32
          },
          src: logoSrc,
          alt: brandTitle
        }),
        /* @__PURE__ */ jsxs3("div", {
          children: [
            /* @__PURE__ */ jsx4("div", {
              style: {
                fontWeight: "bolder",
                fontSize: 14,
                marginBottom: 4
              },
              children: t("package_ui_d5Layout_layoutFrame_h2_title")
            }),
            /* @__PURE__ */ jsx4("div", {
              children: t("package_ui_d5Layout_layoutFrame_title")
            })
          ]
        })
      ]
    });
  };
  return /* @__PURE__ */ jsxs3(Fragment, {
    children: [
      /* @__PURE__ */ jsxs3(StyledSidebar, {
        asideWidth,
        children: [
          isMiniNav ? /* @__PURE__ */ jsx4(StyledLogoMin, {
            src: userLogoUrl || logoSrc,
            alt: userLogoTitle || brandTitle
          }) : renderLogo(),
          /* @__PURE__ */ jsx4(StyledSideNav, {
            children: renderMenu ? renderMenu(isMiniNav) : /* @__PURE__ */ jsx4(Menu, {
              isMiniNav,
              ...menu
            })
          }),
          /* @__PURE__ */ jsx4("div", {
            children: sidebarFooter && sidebarFooter
          })
        ]
      }),
      /* @__PURE__ */ jsx4(Header, {
        onToggleMiniNav,
        headerExtra,
        asideWidth,
        renderToggleIcon,
        isMiniNav
      }),
      /* @__PURE__ */ jsxs3(StyledRight, {
        asideWidth,
        children: [
          /* @__PURE__ */ jsx4(StyledContent, {
            children
          }),
          /* @__PURE__ */ jsx4(Copyright, {
            copyright
          })
        ]
      })
    ]
  });
};

// src/Layout/LayoutNoFrame.tsx
init_esm_shims();
import { Fragment as Fragment2, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var LayoutNoFrame = ({
  bgImg,
  children,
  copyright
}) => /* @__PURE__ */ jsx5(Fragment2, {
  children: /* @__PURE__ */ jsxs4(StyledLayoutNoFrame, {
    bgImg,
    children: [
      children,
      /* @__PURE__ */ jsx5(StyledLayoutNoFrameCopyright, {
        children: copyright
      })
    ]
  })
});

// src/Layout/Layout.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var Layout = ({
  pageType = "frame",
  ...restProps
}) => {
  let L = null;
  if (pageType === "frame") {
    L = LayoutFrame;
  } else {
    L = LayoutNoFrame;
  }
  return /* @__PURE__ */ jsx6(ThemeProvider, {
    theme,
    children: /* @__PURE__ */ jsx6(L, {
      ...restProps
    })
  });
};

// src/Layout/PageCard.tsx
init_esm_shims();
import { H2, Button as Button2, Flex } from "@bigcommerce/big-design";
import { ChevronLeftIcon } from "@bigcommerce/big-design-icons";
import { Fragment as Fragment3, jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var PageCard = ({
  pageTitle,
  children,
  actionsBar,
  hasChildrenBackground = true,
  backIcon = /* @__PURE__ */ jsx7(ChevronLeftIcon, {
    size: "xxLarge"
  }),
  onBack
}) => /* @__PURE__ */ jsxs5(Fragment3, {
  children: [
    /* @__PURE__ */ jsxs5(Flex, {
      alignItems: "center",
      marginBottom: "large",
      children: [
        onBack && /* @__PURE__ */ jsx7(Button2, {
          iconOnly: backIcon,
          variant: "subtle",
          type: "button",
          onClick: onBack
        }),
        /* @__PURE__ */ jsx7(H2, {
          margin: "none",
          children: pageTitle
        })
      ]
    }),
    actionsBar && /* @__PURE__ */ jsx7(StyledBox, {
      marginTop: 8,
      marginBottom: 18,
      children: actionsBar
    }),
    hasChildrenBackground ? /* @__PURE__ */ jsx7(StyledBox, {
      children
    }) : children
  ]
});

// src/D5Input/index.tsx
init_esm_shims();
import {
  Text,
  Flex as Flex2,
  Input
} from "@bigcommerce/big-design";
import {
  ErrorIcon,
  WarningIcon
} from "@bigcommerce/big-design-icons";

// src/D5Input/styled.tsx
init_esm_shims();
import styled3 from "styled-components";
var StyledD5FormGroup = styled3("div")(({
  theme: theme2
}) => ({
  margin: `${theme2.spacing.medium} 0`
}));
var StyledTip = styled3("div")(({
  theme: theme2
}) => ({
  marginTop: theme2.spacing.xSmall,
  display: "flex",
  alignItems: "center"
}));

// src/D5Input/index.tsx
import { Fragment as Fragment4, jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var D5Input = ({
  id,
  label,
  extra,
  error,
  warning,
  ...restProps
}) => /* @__PURE__ */ jsxs6(StyledD5FormGroup, {
  children: [
    /* @__PURE__ */ jsxs6(Flex2, {
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "xxSmall",
      children: [
        /* @__PURE__ */ jsx8("label", {
          htmlFor: id,
          style: {
            cursor: "pointer"
          },
          children: /* @__PURE__ */ jsx8(Text, {
            marginBottom: "none",
            bold: true,
            children: label
          })
        }),
        extra
      ]
    }),
    /* @__PURE__ */ jsx8(Input, {
      ...restProps,
      id
    }),
    error ? /* @__PURE__ */ jsxs6(StyledTip, {
      children: [
        /* @__PURE__ */ jsx8(ErrorIcon, {
          color: "danger"
        }),
        /* @__PURE__ */ jsx8(Text, {
          marginLeft: "xxSmall",
          color: "danger",
          children: error
        })
      ]
    }) : /* @__PURE__ */ jsx8(Fragment4, {}),
    warning ? /* @__PURE__ */ jsxs6(StyledTip, {
      children: [
        /* @__PURE__ */ jsx8(WarningIcon, {
          color: "warning"
        }),
        /* @__PURE__ */ jsx8(Text, {
          marginLeft: "xxSmall",
          color: "warning",
          children: warning
        })
      ]
    }) : /* @__PURE__ */ jsx8(Fragment4, {})
  ]
});

// src/D5Drawer/index.tsx
init_esm_shims();
import React3, {
  useCallback,
  useEffect
} from "react";
import {
  createPortal
} from "react-dom";
import {
  Flex as Flex4,
  Button as Button3,
  H2 as H22
} from "@bigcommerce/big-design";
import {
  CloseIcon
} from "@bigcommerce/big-design-icons";

// src/D5Drawer/styled.tsx
init_esm_shims();
import styled4 from "styled-components";
import {
  Flex as Flex3
} from "@bigcommerce/big-design";
var StyledMaskWrapper = styled4("div")({
  position: "fixed",
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  backgroundColor: "rgba(0,0,0,0.4)",
  animation: "fadeIn .3s forwards",
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0
    },
    "100%": {
      opacity: 1
    }
  }
});
var StyledDrawerWrapper = styled4(Flex3)({
  minWidth: 300,
  height: "100vh",
  backgroundColor: "#fff",
  position: "fixed",
  top: 0,
  right: 0,
  transform: "translateX(100%)",
  animation: "translateInRight .3s linear forwards",
  "@keyframes translateInRight": {
    "0%": {
      transform: "translateX(100%)"
    },
    "50%": {
      transform: "translateX(65%)"
    },
    "100%": {
      transform: "translateX(0)"
    }
  }
});
var StyledDrawerContent = styled4("div")({
  flex: 1,
  overflowX: "hidden"
});

// src/D5Drawer/index.tsx
import { Fragment as Fragment5, jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var D5Drawer = React3.memo((props) => {
  const {
    children,
    title = "",
    isVisible = false,
    maskClosable = true,
    onClose,
    needPadding = true
  } = props;
  const handleClose = useCallback((from = "close_button") => {
    if (from === "mask" && !maskClosable)
      return;
    onClose == null ? void 0 : onClose();
  }, [maskClosable]);
  const stopPropagation = useCallback((e) => {
    e.stopPropagation();
  }, []);
  useEffect(() => {
    document.body.style.overflowY = document.body.scrollHeight > window.innerHeight && isVisible ? "scroll" : "auto";
    document.body.style.position = isVisible ? "fixed" : "static";
  }, [isVisible]);
  return isVisible ? createPortal(
    /* @__PURE__ */ jsxs7(StyledMaskWrapper, {
      onMouseDown: () => handleClose("mask"),
      onScroll: stopPropagation,
      children: [
        /* @__PURE__ */ jsxs7(StyledDrawerWrapper, {
          flexDirection: "column",
          onClick: stopPropagation,
          onMouseDown: stopPropagation,
          children: [
            /* @__PURE__ */ jsxs7(Flex4, {
              padding: "xLarge",
              justifyContent: "space-between",
              alignItems: "center",
              children: [
                /* @__PURE__ */ jsx9(H22, {
                  margin: "none",
                  children: title
                }),
                /* @__PURE__ */ jsx9(Button3, {
                  variant: "subtle",
                  onMouseDown: () => handleClose(),
                  iconOnly: /* @__PURE__ */ jsx9(CloseIcon, {})
                })
              ]
            }),
            /* @__PURE__ */ jsx9(StyledDrawerContent, {
              style: {
                padding: `${needPadding ? "18px" : "0"}`
              },
              children
            })
          ]
        }),
        ","
      ]
    }),
    document.body
  ) : /* @__PURE__ */ jsx9(Fragment5, {});
});

// src/D5Pagination/index.tsx
init_esm_shims();
import {
  Flex as Flex5,
  Pagination
} from "@bigcommerce/big-design";
import React4, {
  useCallback as useCallback2,
  useMemo
} from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var D5Pagination = React4.memo((props) => {
  const {
    flexAlign = "flex-end",
    pagination,
    limitRange,
    onChange
  } = props;
  const currentPage = useMemo(() => pagination.current + 1, [pagination]);
  const handlePageChange = useCallback2((newPage) => onChange({
    ...pagination,
    current: newPage - 1,
    offset: (newPage - 1) * pagination.limit
  }), [onChange, pagination]);
  const handleLimitChange = useCallback2((newLimit) => onChange({
    ...pagination,
    current: 0,
    limit: newLimit,
    offset: 0
  }), [onChange, pagination]);
  return /* @__PURE__ */ jsx10(Flex5, {
    justifyContent: flexAlign,
    marginTop: "xLarge",
    children: /* @__PURE__ */ jsx10(Pagination, {
      currentPage,
      totalItems: pagination.total_count || 0,
      onPageChange: handlePageChange,
      onItemsPerPageChange: handleLimitChange,
      itemsPerPage: pagination.limit,
      itemsPerPageOptions: limitRange || [10, 20, 50]
    })
  });
});

// src/D5Tags/index.tsx
init_esm_shims();
import styled5 from "styled-components";
var D5Tags = styled5.span(({
  theme: theme2,
  color
}) => ({
  color,
  backgroundColor: theme2.helpers.createRGBA(color || theme2.colors.white, 0.05),
  border: `1px solid ${color}`,
  width: "min-content",
  padding: "4px 8px",
  borderRadius: "4px",
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}));

// src/D5Spin/index.tsx
init_esm_shims();

// src/D5Spin/styled.tsx
init_esm_shims();
import styled6 from "styled-components";
var StyledD5Spin = styled6.div(({
  theme: theme2,
  width
}) => ({
  width: `${width}px`,
  aspectRatio: "1",
  border: `2px solid ${theme2.colors.primary20}`,
  borderRadius: "50%",
  margin: "auto",
  animation: "circle infinite 0.75s linear",
  "@keyframes circle": {
    "0%": {
      transform: "rotate(0)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  }
}));

// src/D5Spin/index.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var D5Spin = ({
  width = 30,
  color = "#3C64F4"
}) => /* @__PURE__ */ jsx11(StyledD5Spin, {
  width,
  style: {
    borderBottomColor: color
  }
});

// src/D5Form/index.tsx
init_esm_shims();
var import_dayjs2 = __toESM(require_dayjs_min());
import {
  Form,
  Button as Button4,
  FormGroup,
  Input as Input3,
  Select,
  Flex as Flex8,
  Fieldset,
  MultiSelect,
  Timepicker,
  FormControlLabel as FormControlLabel3,
  Box as Box3,
  Radio,
  Switch,
  Datepicker as Datepicker2,
  Textarea,
  Grid,
  GridItem,
  Text as Text2,
  Counter,
  Checkbox
} from "@bigcommerce/big-design";
import {
  DeleteIcon,
  CloudUploadIcon,
  VisibilityIcon,
  InsertDriveFileIcon
} from "@bigcommerce/big-design-icons";
import {
  useImperativeHandle,
  forwardRef,
  memo,
  useCallback as useCallback3,
  useState as useState4
} from "react";
import { useTranslation as useTranslation2 } from "react-i18next";

// src/D5DateRange/index.tsx
init_esm_shims();
var import_dayjs = __toESM(require_dayjs_min());
import React5, {
  useEffect as useEffect2
} from "react";
import {
  Box,
  Datepicker,
  Flex as Flex6,
  FlexItem,
  FormControlLabel
} from "@bigcommerce/big-design";
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var D5DateRange = React5.memo((props) => {
  const {
    label = "",
    value = [],
    onChange,
    dateFormat = "dd/MM/yyyy",
    locale = "en-US",
    ...rest
  } = props;
  useEffect2(() => {
    if (value[0] && value[1] && (0, import_dayjs.default)(value[0]).valueOf() > (0, import_dayjs.default)(value[1]).valueOf()) {
      onChange == null ? void 0 : onChange(value.reverse());
    }
  }, [value]);
  return /* @__PURE__ */ jsxs8("div", {
    children: [
      label && /* @__PURE__ */ jsx12(FormControlLabel, {
        children: label
      }),
      /* @__PURE__ */ jsxs8(Flex6, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsx12(FlexItem, {
            flexGrow: 1,
            children: /* @__PURE__ */ jsx12(Datepicker, {
              locale,
              min: "01/01/1900",
              max: "01/01/2999",
              onDateChange: (time) => onChange == null ? void 0 : onChange([(0, import_dayjs.default)(time).valueOf(), (value == null ? void 0 : value[1]) || void 0]),
              value: (value == null ? void 0 : value[0]) ? (0, import_dayjs.default)(value == null ? void 0 : value[0]).toISOString() : void 0,
              dateFormat,
              ...rest
            })
          }),
          /* @__PURE__ */ jsx12(Box, {
            marginLeft: "medium",
            marginRight: "medium",
            children: "-"
          }),
          /* @__PURE__ */ jsx12(FlexItem, {
            flexGrow: 1,
            children: /* @__PURE__ */ jsx12(Datepicker, {
              locale,
              min: "01/01/1900",
              max: "01/01/2999",
              onDateChange: (time) => onChange == null ? void 0 : onChange([(value == null ? void 0 : value[0]) || void 0, (0, import_dayjs.default)(time).valueOf()]),
              value: (value == null ? void 0 : value[1]) ? (0, import_dayjs.default)(value == null ? void 0 : value[1]).toISOString() : void 0,
              dateFormat,
              ...rest
            })
          })
        ]
      })
    ]
  });
});

// src/D5FileUpload/index.tsx
init_esm_shims();
import { FileUploader } from "@bigcommerce/big-design";
import React6, { useEffect as useEffect3, useState as useState3, useMemo as useMemo2 } from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var D5FileUpload = React6.memo((props) => {
  const {
    label = "",
    onChange,
    required = false,
    multiple = false,
    error = "",
    rules
  } = props;
  const [files, setFiles] = useState3(null);
  useEffect3(() => {
    if (onChange && files) {
      onChange(files);
    }
  }, [files]);
  const validators = useMemo2(() => {
    if (rules == null ? void 0 : rules.validatorFile) {
      return [
        {
          validator: (file) => !rules.validatorFile(file),
          type: "file-size"
        }
      ];
    }
    return [];
  }, [rules == null ? void 0 : rules.validatorFile]);
  return /* @__PURE__ */ jsx13("div", {
    children: /* @__PURE__ */ jsx13(FileUploader, {
      dropzoneConfig: {
        label: "Drag and drop image here"
      },
      files: files || [],
      label,
      multiple,
      onFilesChange: setFiles,
      required,
      error,
      validators
    })
  });
});

// src/D5Range/index.tsx
init_esm_shims();
import React7 from "react";
import {
  Box as Box2,
  Flex as Flex7,
  FlexItem as FlexItem2,
  FormControlLabel as FormControlLabel2,
  Input as Input2
} from "@bigcommerce/big-design";
import { jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var D5Range = React7.memo((props) => {
  const {
    label = "",
    value = [],
    onChange,
    ...rest
  } = props;
  return /* @__PURE__ */ jsxs9("div", {
    children: [
      label && /* @__PURE__ */ jsx14(FormControlLabel2, {
        children: label
      }),
      /* @__PURE__ */ jsxs9(Flex7, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ jsx14(FlexItem2, {
            flexGrow: 1,
            children: /* @__PURE__ */ jsx14(Input2, {
              placeholder: "start",
              value: (value == null ? void 0 : value[0]) || "",
              onChange: (e) => onChange == null ? void 0 : onChange([e.currentTarget.value, (value == null ? void 0 : value[1]) || ""]),
              ...rest
            })
          }),
          /* @__PURE__ */ jsx14(Box2, {
            marginLeft: "medium",
            marginRight: "medium",
            children: "-"
          }),
          /* @__PURE__ */ jsx14(FlexItem2, {
            flexGrow: 1,
            children: /* @__PURE__ */ jsx14(Input2, {
              placeholder: "end",
              value: (value == null ? void 0 : value[1]) || "",
              onChange: (e) => onChange == null ? void 0 : onChange([(value == null ? void 0 : value[0]) || "", e.currentTarget.value]),
              ...rest
            })
          })
        ]
      })
    ]
  });
});

// src/D5Form/styled.tsx
init_esm_shims();
import styled7 from "styled-components";
var StyledFileInput = styled7("div")(({
  theme: theme2
}) => ({
  position: "relative",
  padding: theme2.spacing.large,
  boxShadow: "rgb(240, 243, 255) 0px 0px 0px 1000px inset",
  border: "1px solid rgb(217, 220, 233)",
  borderRadius: "0.25rem",
  input: {
    cursor: "pointer",
    position: "absolute",
    width: "100%",
    height: "100%",
    left: "0",
    top: "0",
    opacity: "0"
  }
}));

// src/D5Form/index.tsx
import { Fragment as Fragment6, jsx as jsx15, jsxs as jsxs10 } from "react/jsx-runtime";
import { createElement } from "react";
var D5FormLabel = ({
  label,
  sub_label
}) => label ? /* @__PURE__ */ jsx15(FormControlLabel3, {
  children: /* @__PURE__ */ jsxs10("span", {
    children: [
      label,
      /* @__PURE__ */ jsx15("span", {
        style: {
          fontWeight: "normal"
        },
        children: sub_label
      }),
      "\xA0"
    ]
  })
}) : /* @__PURE__ */ jsx15(Fragment6, {});
var D5FormComponent = forwardRef((props, ref) => {
  const {
    submitText = "Save",
    needSubmitbutton = true,
    submitButtonProps = {},
    d5FormData,
    columns = [],
    onChange,
    onSubmit,
    leftExtraContent,
    rightExtraContent,
    fullWidth = true,
    loading
  } = props;
  const [errorMessageMode, setErrorMessageMode] = useState4("unsubmit");
  const [ifShowAllError, setIfShowAllError] = useState4(false);
  const [formItemErrors, setFormItemErrors] = useState4({});
  const { t } = useTranslation2();
  const GetErrorMessage = (formItem, value) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    const formatName = (name) => name.slice(0, 1).toUpperCase() + name.slice(1).toLowerCase();
    if (typeof value === "string") {
      const trimValue = value.trim();
      if (((_a = formItem.rules) == null ? void 0 : _a.required) && !(trimValue == null ? void 0 : trimValue.length)) {
        return typeof formItem.rules.required === "string" ? formItem.rules.required : t("package_ui_d5Form_required", {
          name: formatName(formItem.name)
        });
      }
      if ((_b = formItem.rules) == null ? void 0 : _b.pattern) {
        const pattern = ((_c = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _c.pattern) instanceof RegExp ? {
          value: (_d = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _d.pattern,
          message: t("package_ui_d5Form_correctFormat")
        } : (_e = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _e.pattern;
        if (!((_f = pattern == null ? void 0 : pattern.value) == null ? void 0 : _f.test(trimValue))) {
          return (_g = pattern == null ? void 0 : pattern.message) != null ? _g : t("package_ui_d5Form_correctFormat");
        }
      }
      if ((_h = formItem.rules) == null ? void 0 : _h.maxLength) {
        const defaultMessage = t("package_ui_d5Form_maxLength", {
          name: formatName(formItem.name),
          length: (_i = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _i.maxLength
        });
        const maxLength = typeof ((_j = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _j.maxLength) === "number" ? {
          value: (_k = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _k.maxLength,
          message: defaultMessage
        } : (_l = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _l.maxLength;
        if (trimValue.length > maxLength.value) {
          return (_m = maxLength.message) != null ? _m : defaultMessage;
        }
      }
      if ((_n = formItem.rules) == null ? void 0 : _n.minLength) {
        const defaultMessage = t("package_ui_d5Form_maxLength", {
          name: formatName(formItem.name),
          length: (_o = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _o.maxLength
        });
        const minLength = typeof ((_p = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _p.minLength) === "number" ? {
          value: (_q = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _q.minLength,
          message: defaultMessage
        } : (_r = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _r.minLength;
        if (trimValue.length < minLength.value) {
          return (_s = minLength.message) != null ? _s : defaultMessage;
        }
      }
      if ((_t = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _t.validator) {
        const message = (_u = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _u.validator(trimValue);
        return message != null ? message : t("package_ui_d5Form_please");
      }
    }
    if (formItem.type === "FileImage") {
      const isEmptyValue = !value || value instanceof Array && !value.length;
      if (((_v = formItem.rules) == null ? void 0 : _v.required) && isEmptyValue) {
        return typeof formItem.rules.required === "string" ? formItem.rules.required : t("package_ui_d5Form_required", {
          name: formatName(formItem.name)
        });
      }
      if ((_w = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _w.validatorFile) {
        const message = (_x = formItem == null ? void 0 : formItem.rules) == null ? void 0 : _x.validatorFile(value);
        return message;
      }
      return "";
    }
    if (value instanceof Array) {
      if (((_y = formItem.rules) == null ? void 0 : _y.required) && !(value == null ? void 0 : value.length)) {
        return typeof formItem.rules.required === "string" ? formItem.rules.required : t("package_ui_d5Form_required", {
          name: formatName(formItem.name)
        });
      }
    }
    return "";
  };
  const formItemValidity = useCallback3(
    (formItem) => {
      const error = GetErrorMessage(formItem, d5FormData[formItem.name]);
      if (errorMessageMode === "unsubmit")
        return formItemErrors[formItem.name];
      if (errorMessageMode === "submited" && ifShowAllError) {
        return error ? {
          error
        } : null;
      }
      return {};
    },
    [d5FormData, ifShowAllError, formItemErrors, errorMessageMode]
  );
  const handleFormItemChange = useCallback3(
    (formItem, value) => {
      const errorMessage = GetErrorMessage(formItem, value);
      setFormItemErrors((prev) => ({
        ...prev,
        [formItem.name]: errorMessage ? {
          error: errorMessage
        } : null
      }));
      onChange == null ? void 0 : onChange((prev) => ({
        ...prev,
        [formItem.name]: value
      }));
    },
    []
  );
  const validateForm = useCallback3(() => {
    const formItems = columns.filter((c) => {
      var _a;
      return !!((_a = c.rules) == null ? void 0 : _a.required);
    });
    const errorMessages = formItems.filter(
      (formItem) => !!GetErrorMessage(formItem, d5FormData[formItem.name])
    );
    if (errorMessages == null ? void 0 : errorMessages.length) {
      setIfShowAllError(true);
      formItems.forEach((formItem) => {
        const errorMessage = GetErrorMessage(
          formItem,
          d5FormData[formItem.name]
        );
        setFormItemErrors((prev) => ({
          ...prev,
          [formItem.name]: errorMessage ? {
            error: errorMessage
          } : null
        }));
      });
    }
    return !(errorMessages == null ? void 0 : errorMessages.length);
  }, [columns, d5FormData]);
  const handleD5FormSubmit = useCallback3(
    (e) => {
      var _a, _b;
      e.stopPropagation();
      e.preventDefault();
      const isValidate = validateForm();
      if (!isValidate)
        return;
      if (!((_a = e.currentTarget.form) == null ? void 0 : _a.checkValidity())) {
        setErrorMessageMode("submited");
        return setIfShowAllError(true);
      }
      const hasFormError = Boolean(
        (_b = Object.values(formItemErrors).filter((err) => !!err)) == null ? void 0 : _b.length
      );
      if (hasFormError) {
        return setIfShowAllError(true);
      }
      setIfShowAllError(false);
      onSubmit == null ? void 0 : onSubmit(d5FormData);
    },
    [d5FormData, formItemErrors, columns]
  );
  const handlePhoneChange = useCallback3(
    (formItem, e) => {
      if ((e.currentTarget.value.length === 3 || e.currentTarget.value.length === 7) && e.code !== "Backspace") {
        handleFormItemChange(formItem, `${e.currentTarget.value}-`);
      }
    },
    []
  );
  const handlePriceInputChange = useCallback3(
    (formItem, e) => {
      let formattedValue = "";
      if (e.currentTarget.value) {
        if (e.currentTarget.value.includes(".")) {
          const isNaN = /^\d+$/.test(
            e.currentTarget.value.slice(
              e.currentTarget.value.indexOf(".") + 1,
              e.currentTarget.value.indexOf(".") + 3
            )
          );
          formattedValue = isNaN || e.currentTarget.value.indexOf(".") === e.currentTarget.value.length - 1 ? e.currentTarget.value.slice(
            0,
            e.currentTarget.value.indexOf(".") + 3
          ) : e.currentTarget.value.slice(0, -1);
        } else {
          const value = parseFloat(e.currentTarget.value.replace(/,/g, ""));
          formattedValue = Number.isNaN(value) ? "" : value.toLocaleString("en-US");
        }
      }
      onChange == null ? void 0 : onChange((prev) => ({
        ...prev,
        [formItem.name]: formattedValue
      }));
    },
    []
  );
  const handlePriceBlur = useCallback3(
    (formItem, e) => {
      var _a;
      const { value } = e.currentTarget;
      const num = parseFloat(value);
      const formatted = !Number.isNaN(num) ? num.toFixed(((_a = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _a.decimal_places) || 2) : "";
      onChange == null ? void 0 : onChange((prev) => ({
        ...prev,
        [formItem.name]: formatted
      }));
    },
    []
  );
  const handleFixednumberPriceInputChange = useCallback3(
    (formItem, e) => {
      var _a;
      const raw = e.currentTarget.value;
      const decimal_places = ((_a = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _a.decimal_places) || 2;
      const decimalRegex = new RegExp(`^\\d*\\.?\\d{0,${decimal_places}}$`);
      if (!decimalRegex.test(raw))
        return;
      onChange == null ? void 0 : onChange((prev) => ({
        ...prev,
        [formItem.name]: raw
      }));
    },
    []
  );
  const [isPassword, setIsPassword] = useState4(true);
  useImperativeHandle(
    ref,
    () => ({
      submit: handleD5FormSubmit,
      validate: validateForm
    }),
    [handleD5FormSubmit, validateForm]
  );
  const renderFormItem = useCallback3(
    (formItem) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z;
      switch (formItem.type) {
        case "Input":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_a = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _a.sub_label
                }),
                /* @__PURE__ */ jsx15(Input3, {
                  name: formItem.name,
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || "",
                  onChange: (e) => handleFormItemChange(formItem, e.currentTarget.value),
                  ...formItem.extra,
                  required: !!((_b = formItem.rules) == null ? void 0 : _b.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "PasswordInput":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_c = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _c.sub_label
                }),
                /* @__PURE__ */ jsx15(Input3, {
                  iconRight: /* @__PURE__ */ jsx15(VisibilityIcon, {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: () => {
                      setIsPassword((item) => !item);
                    }
                  }),
                  name: formItem.name,
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || "",
                  onChange: (e) => handleFormItemChange(formItem, e.currentTarget.value),
                  ...formItem.extra,
                  required: !!((_d = formItem.rules) == null ? void 0 : _d.required),
                  type: isPassword ? "password" : "input",
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "PriceInput":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_e = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _e.sub_label
                }),
                /* @__PURE__ */ jsx15(Input3, {
                  iconLeft: /* @__PURE__ */ jsx15(Fragment6, {
                    children: "$"
                  }),
                  name: formItem.name,
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || "",
                  onChange: (e) => handlePriceInputChange(formItem, e),
                  ...formItem.extra,
                  required: !!((_f = formItem.rules) == null ? void 0 : _f.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "FixedNumberInput":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_g = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _g.sub_label
                }),
                /* @__PURE__ */ jsx15(Input3, {
                  iconLeft: /* @__PURE__ */ jsx15(Fragment6, {
                    children: "$"
                  }),
                  name: formItem.name,
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || "",
                  onChange: (e) => handleFixednumberPriceInputChange(formItem, e),
                  onBlur: (e) => handlePriceBlur(formItem, e),
                  ...formItem.extra,
                  required: !!((_h = formItem.rules) == null ? void 0 : _h.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "PhoneInput":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_i = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _i.sub_label
                }),
                /* @__PURE__ */ jsx15(Input3, {
                  name: formItem.name,
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || "",
                  maxLength: 12,
                  placeholder: "000-000-0000",
                  onChange: (e) => handleFormItemChange(formItem, e.currentTarget.value),
                  onKeyDown: (e) => handlePhoneChange(formItem, e),
                  ...formItem.extra,
                  required: !!((_j = formItem.rules) == null ? void 0 : _j.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "FileImage":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsx15(D5FileUpload, {
              ...formItem,
              error: ((_k = formItemErrors[formItem.name]) == null ? void 0 : _k.error) || "",
              onChange: (files) => handleFormItemChange(formItem, files)
            })
          });
        case "FileInput":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                (formItem == null ? void 0 : formItem.label) && /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_l = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _l.sub_label
                }),
                /* @__PURE__ */ jsxs10(StyledFileInput, {
                  children: [
                    /* @__PURE__ */ jsx15(Flex8, {
                      alignItems: "center",
                      flexDirection: "column",
                      children: !(d5FormData == null ? void 0 : d5FormData[formItem.name]) ? /* @__PURE__ */ jsxs10(Fragment6, {
                        children: [
                          /* @__PURE__ */ jsx15(CloudUploadIcon, {
                            size: 40,
                            color: "primary"
                          }),
                          /* @__PURE__ */ jsx15(Text2, {
                            marginTop: "xxSmall",
                            children: t("package_ui_d5Form_fileInput_context")
                          })
                        ]
                      }) : /* @__PURE__ */ jsxs10(Fragment6, {
                        children: [
                          /* @__PURE__ */ jsx15(InsertDriveFileIcon, {
                            size: 40,
                            color: "primary"
                          }),
                          /* @__PURE__ */ jsx15(Text2, {
                            marginTop: "xxSmall",
                            children: d5FormData == null ? void 0 : d5FormData[formItem.name].name
                          })
                        ]
                      })
                    }),
                    /* @__PURE__ */ jsx15("input", {
                      name: formItem.name,
                      onChange: (e) => {
                        handleFormItemChange(
                          formItem,
                          e.currentTarget.files[0] || ""
                        );
                      },
                      ...formItem.extra,
                      required: !!((_m = formItem.rules) == null ? void 0 : _m.required),
                      type: "file",
                      ...formItemValidity(formItem) || {}
                    })
                  ]
                })
              ]
            })
          });
        case "Range":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_n = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _n.sub_label
                }),
                /* @__PURE__ */ jsx15(D5Range, {
                  name: formItem.name,
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || [],
                  onChange: (val) => handleFormItemChange(formItem, val),
                  ...formItem.extra,
                  required: !!((_o = formItem.rules) == null ? void 0 : _o.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "Switch":
          return /* @__PURE__ */ jsxs10(Flex8, {
            flexDirection: ((_p = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _p.layout) === "vertical" ? "column" : "row",
            justifyContent: "space-between",
            alignItems: ((_q = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _q.layout) === "vertical" ? "flex-start" : "center",
            children: [
              /* @__PURE__ */ jsx15(D5FormLabel, {
                label: formItem == null ? void 0 : formItem.label,
                sub_label: (_r = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _r.sub_label
              }),
              ((_s = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _s.is_horizontal) ? /* @__PURE__ */ jsx15(Box3, {
                marginTop: "medium",
                marginBottom: "medium",
                style: { width: "100%" },
                children: /* @__PURE__ */ jsxs10(Flex8, {
                  justifyContent: "space-between",
                  children: [
                    /* @__PURE__ */ jsx15("span", {
                      style: {
                        fontWeight: "normal"
                      },
                      children: (_t = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _t.sub_horizontal_label
                    }),
                    /* @__PURE__ */ jsx15(Switch, {
                      name: formItem.name,
                      checked: d5FormData[formItem.name] || false,
                      onChange: (e) => {
                        var _a2;
                        return !((_a2 = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _a2.disabled) && handleFormItemChange(formItem, e.currentTarget.checked);
                      }
                    })
                  ]
                })
              }) : /* @__PURE__ */ jsx15(Box3, {
                marginTop: "medium",
                marginBottom: "medium",
                children: /* @__PURE__ */ jsx15(Switch, {
                  name: formItem.name,
                  checked: d5FormData[formItem.name] || false,
                  onChange: (e) => {
                    var _a2;
                    return !((_a2 = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _a2.disabled) && handleFormItemChange(formItem, e.currentTarget.checked);
                  }
                })
              })
            ]
          });
        case "Radio":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsx15(Fieldset, {
              legend: formItem.label,
              children: ((formItem == null ? void 0 : formItem.options) || []).map((r) => /* @__PURE__ */ createElement(Box3, {
                ...formItem == null ? void 0 : formItem.extra,
                key: `${formItem.name}-radio-${r.value}`
              }, /* @__PURE__ */ jsx15(Radio, {
                checked: d5FormData[formItem.name] === r.value,
                description: r.description,
                label: r.content,
                name: formItem.name,
                value: r.value,
                onChange: (e) => handleFormItemChange(formItem, e.currentTarget.value)
              })))
            })
          });
        case "CheckBox":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_u = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _u.sub_label
                }),
                /* @__PURE__ */ jsx15(Checkbox, {
                  name: formItem.name,
                  checked: d5FormData[formItem.name] || false,
                  label: (_v = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _v.content,
                  onChange: (e) => handleFormItemChange(formItem, e.currentTarget.checked)
                })
              ]
            })
          });
        case "Select":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_w = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _w.sub_label
                }),
                /* @__PURE__ */ jsx15(Select, {
                  name: formItem.name,
                  value: d5FormData[formItem.name],
                  options: formItem.options || [],
                  filterable: false,
                  onOptionChange: (val) => handleFormItemChange(formItem, val),
                  ...d5FormData[formItem.name] && {
                    action: {
                      actionType: "destructive",
                      content: "Clear",
                      icon: /* @__PURE__ */ jsx15(DeleteIcon, {}),
                      onActionClick: () => {
                        if (!d5FormData[formItem.name])
                          return;
                        handleFormItemChange(formItem, void 0);
                      }
                    }
                  },
                  ...formItem.extra,
                  required: !!((_x = formItem.rules) == null ? void 0 : _x.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "DatePicker":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_y = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _y.sub_label
                }),
                /* @__PURE__ */ jsx15(Datepicker2, {
                  name: formItem.name,
                  value: (0, import_dayjs2.default)(d5FormData[formItem.name]).format(),
                  onDateChange: (val) => handleFormItemChange(formItem, (0, import_dayjs2.default)(val).valueOf()),
                  ...formItem.extra,
                  required: !!((_z = formItem.rules) == null ? void 0 : _z.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "DateRange":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_A = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _A.sub_label
                }),
                /* @__PURE__ */ jsx15(D5DateRange, {
                  name: formItem.name,
                  value: d5FormData[formItem.name],
                  onChange: (val) => handleFormItemChange(formItem, val),
                  ...formItem.extra,
                  required: !!((_B = formItem.rules) == null ? void 0 : _B.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "MultiSelect":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsxs10(Flex8, {
                  justifyContent: "space-between",
                  children: [
                    /* @__PURE__ */ jsx15(D5FormLabel, {
                      label: formItem == null ? void 0 : formItem.label,
                      sub_label: (_C = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _C.sub_label
                    }),
                    ((_D = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _D.multi_select_counter) && /* @__PURE__ */ jsxs10(Flex8, {
                      alignItems: "center",
                      children: [
                        /* @__PURE__ */ jsx15(Checkbox, {
                          label: "",
                          checked: ((_E = d5FormData == null ? void 0 : d5FormData[formItem.name]) == null ? void 0 : _E.length) === (((_F = formItem == null ? void 0 : formItem.options) == null ? void 0 : _F.length) || 1),
                          isIndeterminate: ((_G = d5FormData == null ? void 0 : d5FormData[formItem.name]) == null ? void 0 : _G[0]) !== "" && ((_H = d5FormData == null ? void 0 : d5FormData[formItem.name]) == null ? void 0 : _H.length) > 0 && ((_I = d5FormData == null ? void 0 : d5FormData[formItem.name]) == null ? void 0 : _I.length) < (((_J = formItem == null ? void 0 : formItem.options) == null ? void 0 : _J.length) || 1),
                          onChange: () => {
                            onChange == null ? void 0 : onChange((prev) => {
                              var _a2, _b2, _c2;
                              return {
                                ...prev,
                                [formItem.name]: ((_a2 = d5FormData == null ? void 0 : d5FormData[formItem.name]) == null ? void 0 : _a2.length) === ((_b2 = formItem == null ? void 0 : formItem.options) == null ? void 0 : _b2.length) ? [""] : (_c2 = formItem == null ? void 0 : formItem.options) == null ? void 0 : _c2.map((item) => item.value)
                              };
                            });
                          }
                        }),
                        `${((_K = d5FormData == null ? void 0 : d5FormData[formItem.name]) == null ? void 0 : _K[0]) === "" ? 0 : (_L = d5FormData == null ? void 0 : d5FormData[formItem.name]) == null ? void 0 : _L.length}/${(_M = formItem == null ? void 0 : formItem.options) == null ? void 0 : _M.length} `,
                        (_N = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _N.multi_select_counter
                      ]
                    })
                  ]
                }),
                /* @__PURE__ */ jsx15("div", {
                  style: ((_O = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _O.height) ? {
                    maxHeight: `${formItem.extra.height}px`,
                    overflow: "auto"
                  } : {},
                  children: /* @__PURE__ */ jsx15(MultiSelect, {
                    name: formItem.name,
                    value: d5FormData[formItem.name],
                    options: formItem.options || [],
                    onOptionsChange: (val) => handleFormItemChange(formItem, val),
                    ...formItem.extra,
                    required: !!((_P = formItem.rules) == null ? void 0 : _P.required),
                    ...formItemValidity(formItem) || {}
                  })
                })
              ]
            })
          });
        case "Textarea":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_Q = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _Q.sub_label
                }),
                /* @__PURE__ */ jsx15(Textarea, {
                  name: formItem.name,
                  value: d5FormData[formItem.name],
                  onChange: (e) => handleFormItemChange(formItem, e.currentTarget.value),
                  ...formItem.extra,
                  required: !!((_R = formItem.rules) == null ? void 0 : _R.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "TimePicker":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_S = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _S.sub_label
                }),
                /* @__PURE__ */ jsx15(Timepicker, {
                  name: formItem.name,
                  value: d5FormData[formItem.name],
                  onTimeChange: (val) => handleFormItemChange(formItem, val),
                  ...formItem.extra,
                  required: !!((_T = formItem.rules) == null ? void 0 : _T.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "Counter":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_U = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _U.sub_label
                }),
                /* @__PURE__ */ jsx15(Counter, {
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || ((_V = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _V.min) || 0,
                  onCountChange: (val) => handleFormItemChange(formItem, val),
                  ...formItem.extra,
                  required: !!((_W = formItem.rules) == null ? void 0 : _W.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
        case "Custom":
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: (_X = formItem.render) == null ? void 0 : _X.call(formItem)
          });
        default:
          return /* @__PURE__ */ jsx15(FormGroup, {
            children: /* @__PURE__ */ jsxs10("div", {
              children: [
                /* @__PURE__ */ jsx15(D5FormLabel, {
                  label: formItem == null ? void 0 : formItem.label,
                  sub_label: (_Y = formItem == null ? void 0 : formItem.extra) == null ? void 0 : _Y.sub_label
                }),
                /* @__PURE__ */ jsx15(Input3, {
                  name: formItem.name,
                  value: (d5FormData == null ? void 0 : d5FormData[formItem.name]) || "",
                  onChange: (e) => handleFormItemChange(formItem, e.currentTarget.value),
                  ...formItem.extra,
                  required: !!((_Z = formItem.rules) == null ? void 0 : _Z.required),
                  ...formItemValidity(formItem) || {}
                })
              ]
            })
          });
      }
    },
    [d5FormData, ifShowAllError, isPassword]
  );
  return /* @__PURE__ */ jsxs10(Form, {
    fullWidth,
    children: [
      /* @__PURE__ */ jsx15(Grid, {
        gridColumns: "repeat(24, 1fr)",
        children: columns.map((c) => {
          var _a, _b;
          return /* @__PURE__ */ jsx15(GridItem, {
            gridColumnStart: ((_a = c == null ? void 0 : c.col_span) == null ? void 0 : _a.length) ? c.col_span[0] : "1",
            gridColumnEnd: ((_b = c == null ? void 0 : c.col_span) == null ? void 0 : _b.length) ? c.col_span[1] : "25",
            children: renderFormItem(c)
          }, c.name);
        })
      }),
      needSubmitbutton && /* @__PURE__ */ jsxs10(Flex8, {
        marginTop: "xxLarge",
        justifyContent: (submitButtonProps == null ? void 0 : submitButtonProps.justifyContent) || "flex-end",
        children: [
          leftExtraContent,
          /* @__PURE__ */ jsx15(Button4, {
            ...submitButtonProps,
            type: "submit",
            disabled: loading,
            onClick: handleD5FormSubmit,
            children: loading ? /* @__PURE__ */ jsx15(Flex8, {
              alignItems: "center",
              padding: "xxLarge",
              children: /* @__PURE__ */ jsx15(D5Spin, {
                width: 10
              })
            }) : submitText
          }),
          rightExtraContent
        ]
      })
    ]
  });
});
var D5Form = memo(D5FormComponent);

// src/D5Dropdown/index.tsx
init_esm_shims();
import React9, {
  useCallback as useCallback4,
  useState as useState5
} from "react";
import {
  Popover,
  Button as Button5,
  Flex as Flex9
} from "@bigcommerce/big-design";

// src/D5Dropdown/styled.tsx
init_esm_shims();
import styled8 from "styled-components";
var ItemWrapper = styled8.div({
  color: "black"
});
var Wrapper = styled8.button(({
  theme: theme2
}) => `{
  padding-top: ${theme2.spacing.xSmall};
  padding-bottom: ${theme2.spacing.xSmall};
  padding-left: ${theme2.spacing.medium};
  padding-right: ${theme2.spacing.medium};
  border: none;
  background: ${theme2.colors.white};
  color: ${theme2.colors.primary};
  cursor: pointer;
  border-radius: ${theme2.borderRadius.normal};
  &:hover, 
  &:active {
    background: rgb(240, 243, 255);
  }
}`);

// src/D5Dropdown/index.tsx
import { Fragment as Fragment7, jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var D5Dropdown = React9.memo((props) => {
  const {
    toggle,
    items,
    placement = "bottom"
  } = props;
  const [isOpen, setIsOpen] = useState5(false);
  const [buttonRef, setButtonRef] = useState5(null);
  const handleDropdownItemClick = useCallback4((i) => {
    var _a;
    (_a = i == null ? void 0 : i.onItemClick) == null ? void 0 : _a.call(i, i);
    setIsOpen(false);
  }, []);
  return /* @__PURE__ */ jsxs11(Fragment7, {
    children: [
      /* @__PURE__ */ jsx16(Wrapper, {
        ref: setButtonRef,
        onClick: () => setIsOpen((prev) => !prev),
        children: toggle
      }),
      /* @__PURE__ */ jsx16(Popover, {
        placement,
        anchorElement: buttonRef,
        isOpen,
        label: "Example Popover",
        onClose: () => setIsOpen(false),
        children: /* @__PURE__ */ jsx16(Flex9, {
          flexDirection: "column",
          justifyContent: "flex-start",
          children: (items || []).map((i) => /* @__PURE__ */ jsx16(Button5, {
            variant: "subtle",
            iconLeft: i == null ? void 0 : i.icon,
            disabled: (i == null ? void 0 : i.disabled) || false,
            onClick: () => handleDropdownItemClick(i),
            children: (i == null ? void 0 : i.disabled) ? /* @__PURE__ */ jsx16(Fragment7, {
              children: i.content
            }) : /* @__PURE__ */ jsx16(ItemWrapper, {
              children: i == null ? void 0 : i.content
            })
          }, i == null ? void 0 : i.hash))
        })
      })
    ]
  });
});

// src/D5Loading/index.tsx
init_esm_shims();
import { Flex as Flex10, Box as Box4, Text as Text3 } from "@bigcommerce/big-design";
import React10 from "react";
import { createPortal as createPortal2 } from "react-dom";
import { useTranslation as useTranslation3 } from "react-i18next";

// src/D5Loading/styled.tsx
init_esm_shims();
import styled9 from "styled-components";
var CenterBox = styled9.div({
  position: "fixed",
  width: "100%",
  height: "100vh",
  left: "0",
  top: "0",
  background: "rgba(255, 255, 255, 1)",
  zIndex: 9999,
  userSelect: "none",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end"
});
var LoadingWrapper = styled9.div({
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translateX(-50%) translateY(-50%)"
});

// src/D5Loading/index.tsx
import { Fragment as Fragment8, jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var GlobalLoading = () => {
  const { t } = useTranslation3();
  return /* @__PURE__ */ jsxs12(CenterBox, {
    children: [
      /* @__PURE__ */ jsxs12(LoadingWrapper, {
        children: [
          /* @__PURE__ */ jsx17(D5Spin, {}),
          /* @__PURE__ */ jsx17(Box4, {
            style: {
              textAlign: "center"
            },
            children: /* @__PURE__ */ jsx17(Text3, {
              marginTop: "xLarge",
              children: t("package_ui_d5Loading_context")
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs12(Box4, {
        padding: "medium",
        children: [
          t("package_ui_d5Loading_certification_left"),
          " ",
          new Date().getFullYear(),
          " ",
          t("package_ui_d5Loading_certification_right")
        ]
      })
    ]
  });
};
var D5Loading = React10.memo((props) => {
  const { isLoading, isGlobal = false, children } = props;
  if (isGlobal) {
    return createPortal2(/* @__PURE__ */ jsx17(GlobalLoading, {}), document.body);
  }
  return isLoading ? /* @__PURE__ */ jsx17(Flex10, {
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "xxLarge",
    paddingBottom: "xxLarge",
    children: /* @__PURE__ */ jsx17(D5Spin, {})
  }) : /* @__PURE__ */ jsx17(Fragment8, {
    children
  });
});

// src/D5Import/index.tsx
init_esm_shims();
import { Modal } from "@bigcommerce/big-design";
import { useEffect as useEffect4, useMemo as useMemo3, useState as useState6 } from "react";
import { useTranslation as useTranslation4 } from "react-i18next";
import { jsx as jsx18, jsxs as jsxs13 } from "react/jsx-runtime";
var D5Import = ({
  isOpen,
  setIsOpen,
  extra,
  useImport,
  params,
  Message,
  interfaceName,
  successMessage,
  checkFileType
}) => {
  const [importFormValue, setImportFormValue] = useState6({
    file: ""
  });
  const { t } = useTranslation4();
  const currentFormData = useMemo3(() => {
    const formData = new FormData();
    formData.append("file", importFormValue.file);
    if (params && (params == null ? void 0 : params.length)) {
      params == null ? void 0 : params.forEach((item) => {
        formData.append(item.key, item.value);
      });
    }
    return formData;
  }, [importFormValue.file]);
  const { fetchData, error, code } = useImport(interfaceName, currentFormData);
  useEffect4(() => {
    if (code === 200) {
      setIsOpen(false);
      Message == null ? void 0 : Message.success(successMessage != null ? successMessage : t("package_ui_d5Import_success"));
    }
  }, [code]);
  useEffect4(() => {
    if (error) {
      setIsOpen(false);
      Message == null ? void 0 : Message.error(error);
    }
  }, [error]);
  const handleSubmit = () => {
    fetchData == null ? void 0 : fetchData();
  };
  return /* @__PURE__ */ jsxs13(Modal, {
    actions: [
      {
        text: t("package_ui_d5Import_btn_cancelText"),
        variant: "secondary",
        onClick: () => setIsOpen(false)
      },
      {
        text: t("package_ui_d5Import_btn_okText"),
        disabled: checkFileType ? (importFormValue == null ? void 0 : importFormValue.file.type) !== checkFileType : false,
        onClick: () => handleSubmit()
      }
    ],
    closeOnClickOutside: true,
    closeOnEscKey: true,
    header: " ",
    isOpen,
    onClose: () => setIsOpen(false),
    children: [
      extra,
      /* @__PURE__ */ jsx18(D5Form, {
        d5FormData: importFormValue,
        onChange: setImportFormValue,
        needSubmitbutton: false,
        columns: [
          {
            type: "FileInput",
            label: "",
            name: "file"
          }
        ]
      })
    ]
  });
};

// src/D5Export/index.tsx
init_esm_shims();
import {
  Box as Box5,
  Flex as Flex11,
  Form as Form2,
  FormGroup as FormGroup2,
  H2 as H23,
  Modal as Modal2,
  Radio as Radio2,
  Text as Text4
} from "@bigcommerce/big-design";
import { ErrorIcon as ErrorIcon2 } from "@bigcommerce/big-design-icons";
import { useEffect as useEffect5, useState as useState7 } from "react";
import { useTranslation as useTranslation5 } from "react-i18next";
import { jsx as jsx19, jsxs as jsxs14 } from "react/jsx-runtime";
var D5Export = ({
  isOpen,
  setIsOpen,
  useExport,
  Message,
  interfaceName,
  successMessage,
  data,
  showRadioOptions,
  radioOptions = [],
  onRadioChange,
  optionParamName
}) => {
  const [exportData, setExportData] = useState7(data);
  const { fetchData, error, code } = useExport(interfaceName, exportData);
  const [selectedValue, setSelectedValue] = useState7("");
  const { t } = useTranslation5();
  useEffect5(() => {
    if (showRadioOptions && radioOptions.length > 0) {
      const defaultOption = radioOptions == null ? void 0 : radioOptions.find(
        (option) => option.defaultChecked
      );
      const initialValue = (defaultOption == null ? void 0 : defaultOption.value) || radioOptions[0].value;
      setSelectedValue(initialValue);
      onRadioChange == null ? void 0 : onRadioChange(initialValue);
    }
  }, [showRadioOptions, radioOptions, onRadioChange]);
  useEffect5(() => {
    const newExportData = { ...data };
    if (showRadioOptions && optionParamName && selectedValue) {
      newExportData[optionParamName] = selectedValue;
    }
    setExportData(newExportData);
  }, [showRadioOptions, optionParamName, selectedValue, data]);
  useEffect5(() => {
    setIsOpen(false);
    if (code === 200) {
      Message == null ? void 0 : Message.success(successMessage != null ? successMessage : t("package_ui_d5Export_success"));
    } else if (error) {
      Message == null ? void 0 : Message.error(error);
    }
  }, [code]);
  const handleRadioChange = (value) => {
    setSelectedValue(value);
    onRadioChange == null ? void 0 : onRadioChange(value);
  };
  const renderRadioOptions = () => {
    if (!showRadioOptions || radioOptions.length === 0)
      return null;
    return /* @__PURE__ */ jsxs14(Box5, {
      marginTop: "medium",
      marginBottom: "medium",
      children: [
        /* @__PURE__ */ jsx19(Text4, {
          marginBottom: "small",
          children: t("package_ui_d5Export_order_range")
        }),
        /* @__PURE__ */ jsx19(Form2, {
          children: /* @__PURE__ */ jsx19(FormGroup2, {
            children: radioOptions.map((option) => /* @__PURE__ */ jsx19(Radio2, {
              name: "exportOption",
              value: option.value,
              label: option.label,
              checked: selectedValue === option.value,
              onChange: (e) => handleRadioChange(e.target.value)
            }, option.value))
          })
        })
      ]
    });
  };
  const handleSubmit = () => {
    fetchData == null ? void 0 : fetchData();
  };
  return /* @__PURE__ */ jsxs14(Modal2, {
    actions: [
      {
        text: t("package_ui_d5Export_btn_cancelText"),
        variant: "secondary",
        onClick: () => setIsOpen(false)
      },
      {
        text: t("package_ui_d5Export_btn_okText"),
        onClick: () => handleSubmit(),
        disabled: showRadioOptions && !selectedValue
      }
    ],
    closeOnClickOutside: true,
    closeOnEscKey: true,
    header: " ",
    isOpen,
    onClose: () => setIsOpen(false),
    children: [
      /* @__PURE__ */ jsxs14(Flex11, {
        children: [
          /* @__PURE__ */ jsx19(Box5, {
            paddingRight: "small",
            children: /* @__PURE__ */ jsx19(ErrorIcon2, {
              size: 32,
              color: "#0D52FF"
            })
          }),
          /* @__PURE__ */ jsx19(H23, {
            children: t("package_ui_d5Export_title")
          })
        ]
      }),
      renderRadioOptions(),
      /* @__PURE__ */ jsx19(Text4, {
        bold: true,
        children: t("package_ui_d5Export_context")
      })
    ]
  });
};

// src/D5AccordionCheckBox/index.tsx
init_esm_shims();
import {
  useEffect as useEffect6,
  useMemo as useMemo4,
  useRef,
  useState as useState8
} from "react";
import {
  Checkbox as Checkbox2
} from "@bigcommerce/big-design";
import {
  ExpandMoreIcon
} from "@bigcommerce/big-design-icons";

// src/D5AccordionCheckBox/styled.tsx
init_esm_shims();
import styled10 from "styled-components";
var StyledAccordionHeader = styled10("div")(({
  theme: theme2
}) => ({
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid rgb(217, 220, 233)",
  ":hover": {
    backgroundColor: theme2.colors.primary10
  },
  ":first-child": {
    borderTop: "1px solid rgb(217, 220, 233)"
  }
}));
var StyledAccordionIcon = styled10("div")({
  cursor: "pointer",
  transition: "transform 0.3s"
});
var StyledExpansion = styled10("div")({
  transition: "height 0.5s, padding 0.3s"
});
var StyledChechboxWrapper = styled10("div")(({
  theme: theme2
}) => ({
  cursor: "pointer",
  padding: `${theme2.spacing.xSmall} ${theme2.spacing.xLarge}`,
  ":hover": {
    backgroundColor: theme2.colors.primary10
  }
}));

// src/D5AccordionCheckBox/index.tsx
import { Fragment as Fragment9, jsx as jsx20, jsxs as jsxs15 } from "react/jsx-runtime";
var D5AccordionCheckBox = ({
  data,
  setFormValue,
  formValue = {
    [data.module]: []
  },
  isChildren = false,
  maxHeight,
  permissionCheckedStatus,
  setPermissionCheckedStatus
}) => {
  var _a, _b;
  const [isExpansion, setIsExpansion] = useState8(false);
  const [checkedItemsValue, setCheckedItemsValue] = useState8([]);
  const childRef = useRef(null);
  useEffect6(() => {
    setCheckedItemsValue(data.items.map((item) => item.value));
  }, [data.items]);
  useEffect6(() => {
    setPermissionCheckedStatus == null ? void 0 : setPermissionCheckedStatus(1);
  }, [formValue]);
  const permissionCheckedStatusMap = {
    0: [],
    2: data.items.map((item) => item.value)
  };
  useEffect6(() => {
    if (permissionCheckedStatus && permissionCheckedStatus !== 1) {
      setFormValue({
        [data.module]: permissionCheckedStatusMap[permissionCheckedStatus]
      });
    }
  }, [permissionCheckedStatus, data]);
  const handleChildCheckBoxClick = (e, item) => {
    var _a2, _b2;
    e.preventDefault();
    setFormValue({
      [data.module]: !((_a2 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a2.includes(item.value)) ? [
        ...(formValue == null ? void 0 : formValue[data.module]) || "",
        item.value
      ] : (_b2 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _b2.filter((i) => i !== item.value)
    });
  };
  const isFatherCheckBoxChecked = useMemo4(
    () => {
      var _a2;
      return checkedItemsValue.every((element) => {
        var _a3;
        return (_a3 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a3.includes(element);
      }) && !!((_a2 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a2.length);
    },
    [formValue == null ? void 0 : formValue[data.module]]
  );
  const isFatherCheckBoxIndeterminate = useMemo4(
    () => {
      var _a2;
      return checkedItemsValue.some((element) => {
        var _a3;
        return (_a3 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a3.includes(element);
      }) || !!((_a2 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a2.length);
    },
    [formValue == null ? void 0 : formValue[data.module]]
  );
  return /* @__PURE__ */ jsxs15(Fragment9, {
    children: [
      /* @__PURE__ */ jsxs15(StyledAccordionHeader, {
        onClick: () => {
          setIsExpansion(!isExpansion);
        },
        style: {
          padding: `16px ${isChildren ? "28px" : "20px"}`
        },
        children: [
          /* @__PURE__ */ jsx20(Checkbox2, {
            label: data.module,
            checked: isFatherCheckBoxChecked,
            isIndeterminate: isFatherCheckBoxIndeterminate,
            onChange: () => {
              var _a2;
              setFormValue({
                [data.module]: data.items.length !== ((_a2 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a2.length) ? data.items.map((item) => item.value) : []
              });
            }
          }),
          /* @__PURE__ */ jsx20(StyledAccordionIcon, {
            style: {
              transform: `rotate(${isExpansion ? "-180deg" : "0"})`
            },
            children: /* @__PURE__ */ jsx20(ExpandMoreIcon, {})
          })
        ]
      }),
      /* @__PURE__ */ jsx20(StyledExpansion, {
        style: {
          height: `${isExpansion ? `${(_a = childRef == null ? void 0 : childRef.current) == null ? void 0 : _a.clientHeight}px` : "0"}`,
          padding: `${isExpansion ? `8px ${isChildren ? "22px" : "16px"}` : `0 ${isChildren ? "22px" : "16px"}`}`,
          borderBottom: `${isExpansion ? "1px solid rgb(217, 220, 233)" : "none"}`,
          maxHeight,
          overflow: `${maxHeight ? "auto" : "hidden"}`
        },
        children: /* @__PURE__ */ jsx20("div", {
          ref: childRef,
          children: (_b = data == null ? void 0 : data.items) == null ? void 0 : _b.map((item) => {
            var _a2;
            return /* @__PURE__ */ jsx20(StyledChechboxWrapper, {
              onClick: (e) => handleChildCheckBoxClick(e, item),
              children: /* @__PURE__ */ jsx20(Checkbox2, {
                label: item.label,
                checked: (_a2 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a2.includes(item.value),
                onChange: (v) => {
                  var _a3;
                  setFormValue({
                    [data.module]: v.target.checked ? [
                      ...(formValue == null ? void 0 : formValue[data.module]) || "",
                      item.value
                    ] : (_a3 = formValue == null ? void 0 : formValue[data.module]) == null ? void 0 : _a3.filter((i) => i !== item.value)
                  });
                }
              })
            }, item.value);
          })
        })
      })
    ]
  });
};

// src/D5Accordion/index.tsx
init_esm_shims();
import {
  useEffect as useEffect7,
  useRef as useRef2,
  useState as useState9
} from "react";
import {
  ExpandMoreIcon as ExpandMoreIcon2
} from "@bigcommerce/big-design-icons";
import {
  Box as Box6
} from "@bigcommerce/big-design";

// src/D5Accordion/styled.tsx
init_esm_shims();
import styled11 from "styled-components";
var StyledAccordionHeader2 = styled11("div")(({
  theme: theme2
}) => ({
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  padding: `${theme2.spacing.large} ${theme2.spacing.xLarge} ${theme2.spacing.large} ${theme2.spacing.large}`,
  ":hover": {
    backgroundColor: theme2.colors.primary10
  },
  ":first-child": {
    borderTop: "1px solid rgb(217, 220, 233)"
  }
}));
var StyledAccordionIcon2 = styled11("div")({
  cursor: "pointer",
  transition: "transform 0.3s"
});
var StyledExpansion2 = styled11("div")({
  overflow: "hidden",
  transition: "height 0.5s, padding 0.3s"
});

// src/D5Accordion/index.tsx
import { Fragment as Fragment10, jsx as jsx21, jsxs as jsxs16 } from "react/jsx-runtime";
var D5Accordion = ({
  header,
  children,
  needBorder = true,
  isExpansionShow = false,
  needDefaultHeader = true
}) => {
  var _a;
  const [isExpansion, setIsExpansion] = useState9(false);
  const [isAuto, setIsAuto] = useState9(false);
  const [isMounted, setIsMounted] = useState9(false);
  const childRef = useRef2(null);
  useEffect7(() => {
    if (isAuto) {
      setTimeout(() => {
        setIsAuto(false);
      }, 500);
    }
  }, [isAuto]);
  const handleHeaderClick = () => {
    if (!isExpansion) {
      setIsExpansion(true);
      setIsAuto(true);
    } else {
      setIsAuto(true);
      setTimeout(() => {
        setIsExpansion(false);
      }, 100);
    }
  };
  useEffect7(() => {
    if (isMounted) {
      handleHeaderClick();
    } else {
      setIsMounted(true);
    }
  }, [isExpansionShow]);
  return /* @__PURE__ */ jsxs16(Fragment10, {
    children: [
      needDefaultHeader ? /* @__PURE__ */ jsxs16(StyledAccordionHeader2, {
        onClick: handleHeaderClick,
        children: [
          /* @__PURE__ */ jsx21(Box6, {
            onClick: (e) => {
              e.stopPropagation();
            },
            children: header
          }),
          /* @__PURE__ */ jsx21(StyledAccordionIcon2, {
            style: {
              transform: `rotate(${isExpansion ? "-180deg" : "0"})`
            },
            children: /* @__PURE__ */ jsx21(ExpandMoreIcon2, {})
          })
        ]
      }) : /* @__PURE__ */ jsx21(Fragment10, {
        children: header
      }),
      /* @__PURE__ */ jsx21(StyledExpansion2, {
        style: {
          height: `${isExpansion ? `${isAuto ? `${(_a = childRef == null ? void 0 : childRef.current) == null ? void 0 : _a.clientHeight}px` : "auto"}` : "0"}`,
          borderTop: `${!isExpansion && !needBorder ? "1px solid rgb(217, 220, 233)" : "none"}`
        },
        children: /* @__PURE__ */ jsx21("div", {
          ref: childRef,
          children
        })
      })
    ]
  });
};

// src/D5ImageUpload/index.tsx
init_esm_shims();
import { Flex as Flex12, Text as Text5 } from "@bigcommerce/big-design";
import React13, { useCallback as useCallback5 } from "react";
import { useTranslation as useTranslation6 } from "react-i18next";

// ../../node_modules/react-icons/bi/index.esm.js
init_esm_shims();

// ../../node_modules/react-icons/lib/esm/index.js
init_esm_shims();

// ../../node_modules/react-icons/lib/esm/iconsManifest.js
init_esm_shims();

// ../../node_modules/react-icons/lib/esm/iconBase.js
init_esm_shims();
import React12 from "react";

// ../../node_modules/react-icons/lib/esm/iconContext.js
init_esm_shims();
import React11 from "react";
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React11.createContext && React11.createContext(DefaultContext);

// ../../node_modules/react-icons/lib/esm/iconBase.js
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i) {
    return React12.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return React12.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return React12.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React12.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React12.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

// ../../node_modules/react-icons/bi/index.esm.js
function BiEditAlt(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "d": "M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" } }] })(props);
}

// ../../node_modules/react-icons/fi/index.esm.js
init_esm_shims();
function FiUpload(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" } }, { "tag": "polyline", "attr": { "points": "17 8 12 3 7 8" } }, { "tag": "line", "attr": { "x1": "12", "y1": "3", "x2": "12", "y2": "15" } }] })(props);
}

// src/D5ImageUpload/styled.tsx
init_esm_shims();
import styled12 from "styled-components";
var ImageUploadWrapper = styled12.div({
  width: "86px",
  height: "86px",
  borderRadius: "50%",
  overflow: "hidden",
  background: "rgba(204, 204, 204, 0.2)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer"
});
var UploadLabel = styled12.label({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer"
});
var Image = styled12.img({
  width: "100%",
  height: "100%",
  fontSize: "0"
});
var ImageWrapper = styled12.div({
  width: "100%",
  height: "100%",
  position: "relative"
});
var IconWrapper = styled12.label`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(255,255,255,0.2);
  display: none;
  zIndex: 80;
  cursor: pointer;
  ${ImageWrapper}:hover & {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
var InvisibleInput = styled12.input({
  width: 0,
  height: 0
});

// src/D5ImageUpload/index.tsx
import { jsx as jsx22, jsxs as jsxs17 } from "react/jsx-runtime";
var D5ImageUpload = React13.memo((props) => {
  const { loading = false, imageUrl, onChange } = props;
  const { t } = useTranslation6();
  const handleImageChange = useCallback5(
    (e) => {
      var _a, _b;
      const file = (_b = (_a = e == null ? void 0 : e.currentTarget) == null ? void 0 : _a.files) == null ? void 0 : _b[0];
      if (!file)
        return;
      const isValid = ["image/jpeg", "image/png"].indexOf(file.type) > -1;
      if (!isValid)
        return;
      onChange == null ? void 0 : onChange(file);
    },
    []
  );
  return /* @__PURE__ */ jsx22(ImageUploadWrapper, {
    children: /* @__PURE__ */ jsx22(D5Loading, {
      isLoading: loading,
      children: imageUrl ? /* @__PURE__ */ jsxs17(ImageWrapper, {
        children: [
          /* @__PURE__ */ jsx22(Image, {
            src: imageUrl || "",
            alt: t("package_ui_d5ImageUpload_alt")
          }),
          /* @__PURE__ */ jsxs17(IconWrapper, {
            htmlFor: "upload-input-edit",
            children: [
              /* @__PURE__ */ jsx22(BiEditAlt, {
                size: 24
              }),
              /* @__PURE__ */ jsx22(InvisibleInput, {
                id: "upload-input-edit",
                type: "file",
                onChange: handleImageChange
              })
            ]
          })
        ]
      }) : /* @__PURE__ */ jsxs17(UploadLabel, {
        htmlFor: "upload-input",
        children: [
          /* @__PURE__ */ jsx22(InvisibleInput, {
            id: "upload-input",
            type: "file",
            onChange: handleImageChange
          }),
          /* @__PURE__ */ jsxs17(Flex12, {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            children: [
              /* @__PURE__ */ jsx22(FiUpload, {
                size: 24
              }),
              /* @__PURE__ */ jsx22(Text5, {
                children: t("package_ui_d5ImageUpload_upload")
              })
            ]
          })
        ]
      })
    })
  });
});

// src/D5Deadline/index.tsx
init_esm_shims();
import styled13 from "styled-components";
var D5Deadline = styled13.div({
  width: "100%",
  height: 1,
  background: "#ccc",
  margin: "16px 0"
});
export {
  D5Accordion,
  D5AccordionCheckBox,
  StyledBox as D5Box,
  D5DateRange,
  D5Deadline,
  D5Drawer,
  D5Dropdown,
  D5Export,
  D5FileUpload,
  D5Form,
  D5ImageUpload,
  D5Import,
  D5Input,
  D5Loading,
  D5Pagination,
  D5Range,
  D5Spin,
  D5Tags,
  Layout,
  Menu,
  PageCard
};
